import { isProxy, toRaw } from 'vue';

export default function unProxy(v) {
  return isProxy(v) ? toRaw(v) : v;
}
